import { render, staticRenderFns } from "./authorizationMoreOpearate.vue?vue&type=template&id=0f3a69b4&scoped=true"
import script from "./authorizationMoreOpearate.vue?vue&type=script&lang=js"
export * from "./authorizationMoreOpearate.vue?vue&type=script&lang=js"
import style0 from "./authorizationMoreOpearate.vue?vue&type=style&index=0&id=0f3a69b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3a69b4",
  null
  
)

export default component.exports